import { Typography } from '@mui/material';
import { Grid } from '@mui/material';
import { Box } from '@mui/system';
import GhostDialog from 'components/dialog/GhostDialog';
import FieldsByPatterns from '../verification/patternsDynamicFields/FieldsByPatterns';
import { Divider } from '@mui/material';
import { Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { VerificationTechniquesLabelEnum, VerificationTechniquesType } from 'types/verification';

import { useDispatch } from 'react-redux';
import { clearCurrentFieldName, clearsetHeaderPatternTextRoi, clearsetPatternTextRoi } from 'store/reducers/columnSlice';
import { useTheme } from '@mui/material';
const translate = (key: string) => (window as any).translate(key);

interface Props {
  open: boolean;
  addEditPatternType: 'ADD' | 'EDIT' | false;
  fileName: string;
  addInsertInitialData: any;
  rectImageContent: string;
  onCancel: () => void;
  isSubmitLoading: boolean;
  onSubmit: () => void;
  patternFormRef: any;
  selectedFieldName: string;
  selectedTechniqueName: VerificationTechniquesType;
  currentPageNumber?: any;
  setshowDialog?: any;
  disableLabelRubberband?: any;
  setShowLabelRubberbandDialog?: any;
  setAddEditPatternType?: any;
  headerData?: any;
}

const AssuranceAddPatternDialog = ({
  open,
  addEditPatternType,
  fileName,
  addInsertInitialData,
  rectImageContent,
  onCancel,
  isSubmitLoading,
  onSubmit,
  patternFormRef,
  currentPageNumber,
  selectedFieldName,
  setshowDialog,
  selectedTechniqueName,
  setShowLabelRubberbandDialog,
  disableLabelRubberband,
  setAddEditPatternType,
  headerData
}: Props) => {
  const dispatch = useDispatch();
  const theme = useTheme();

  return (
    <GhostDialog
      className="image-viewer-finish-modal image-viewer-dubber-band-dialog"
      open={open}
      onClose={() => {}}
      customMaxWidth="500px"
    >
      <Box
        className="move-to-exception-form-container popup-content-background-image"
        p="20px"
        pt="15px"
        sx={{ backgroundColor: theme.palette.mode === 'dark' ? theme.palette.background.paper : theme.palette.background.default }}
      >
        <Grid container justifyContent="space-between" alignItems={'flex-end'}>
          <Grid item>
            <Typography lineHeight="24px" variant="h3" className="popup-title">
              {addEditPatternType === 'ADD' ? 'Add' : 'Edit'} {selectedTechniqueName === 'Context Based' ? 'Value' : 'Pattern'}
            </Typography>
          </Grid>
          <Grid item>
            <Typography textAlign="right" fontSize="10px">
              {translate('pages.review.verification.labels.fileName')}
            </Typography>
            <Typography textAlign="right" fontSize="12px" className="text-bold">
              {fileName}
            </Typography>
          </Grid>
        </Grid>
        <Divider sx={{ my: 1 }} className="popup-tittle-divider" />
        <Box pt={2} px={2}>
          <FieldsByPatterns
            rectImageContent={rectImageContent}
            patternFormRef={patternFormRef}
            selectedFieldName={selectedFieldName}
            techniqueType={VerificationTechniquesLabelEnum[selectedTechniqueName]}
            setShowLabelRubberbandDialog={setShowLabelRubberbandDialog}
            currentPageNumber={currentPageNumber}
            setAddEditPatternType={setAddEditPatternType}
            initialData={addInsertInitialData}
            disableLabelRubberband={disableLabelRubberband}
            setshowDialog={setshowDialog}
            headerData={headerData}
            onCancel={onCancel}
            isEdit={addEditPatternType === 'EDIT'}
          />
        </Box>
      </Box>
      <Box p="30px" sx={{ backgroundColor: theme.palette.background.paper }}>
        <Grid container justifyContent="space-around" alignItems="center" columnSpacing="30px">
          <Grid item>
            <Button
              variant="contained"
              className="buttonSecondary"
              onClick={() => {
                onCancel();
                dispatch(clearCurrentFieldName());
                dispatch(clearsetPatternTextRoi());
                dispatch(clearsetHeaderPatternTextRoi());
              }}
            >
              CANCEL
            </Button>
          </Grid>
          <Grid item>
            <LoadingButton
              variant="contained"
              color="primary"
              loading={isSubmitLoading}
              onClick={() => {
                onSubmit();
                dispatch(clearCurrentFieldName());
                dispatch(clearsetPatternTextRoi());
                dispatch(clearsetHeaderPatternTextRoi());
              }}
            >
              {addEditPatternType === 'ADD' ? 'ADD' : 'SAVE'}
            </LoadingButton>
          </Grid>
        </Grid>
      </Box>
    </GhostDialog>
  );
};

export default AssuranceAddPatternDialog;
